const generatePreview = (
  url: string | undefined,
  options: {
    format?: "webp";
    quality?: number;
    raw?: boolean;
  } = {}
) => {
  if (!url) return "";

  const { format, quality, raw } = options;
  const params = new URLSearchParams();

  if (raw) params.append("raw", "true");

  const transformations = [];

  if (format) {
    const formatString = quality ? `format:${format},${quality}` : `format:${format}`;
    transformations.push(formatString);
  }

  if (transformations.length > 0) {
    params.append("t", transformations.join("%7C"));
  }

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${params.toString()}`;
};

export const usePreviews = () => {
  const getPreview = (url: string | undefined) => {
    return generatePreview(url, { format: "webp", quality: 50 });
  };

  const getRawFile = (url: string | undefined) => {
    return generatePreview(url, { raw: true });
  };

  return { generatePreview, getPreview, getRawFile };
};
